<form [formGroup]="form">
  <ion-row class="ion-margin-bottom ion-margin-top">
    <!-- Location Code -->
    <ion-col size="2">
      <app-form-text-field
        appUppercase
        [labelText]="CONSTANTS.LOCATION_CODE"
        [minLength]="3"
        [maxLength]="10"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [autoCapitalizeCharacters]="true"
        [control]="'code'"
      ></app-form-text-field>
    </ion-col>

    <!-- Location Name -->
    <ion-col size="4">
      <app-form-text-field
        [labelText]="CONSTANTS.LOCATION_NAME"
        [maxLength]="30"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [autoCapitalizeCharacters]="true"
        [control]="'name'"
      ></app-form-text-field>
    </ion-col>

    <!-- PORT CODE -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.PORT_CODE"
        [minLength]="4"
        [maxLength]="5"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [control]="'slic'"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="true"
      ></app-form-text-field>
    </ion-col>

    <!-- PKG Slic -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.PKG_SLIC"
        [minLength]="4"
        [maxLength]="5"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [control]="'pkgSlic'"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="true"
      ></app-form-text-field>
    </ion-col>

    <!-- Billing Port Code -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.BILLING_PORT_CODE"
        [minLength]="4"
        [maxLength]="5"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [control]="'billingPortCode'"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="false"
      ></app-form-text-field>
    </ion-col>
  </ion-row>

  <!-- SECOND ROW-->
  <ion-row class="ion-margin-bottom">
    <!-- Region Code -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.REGION"
        [maxLength]="2"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [autoCapitalizeCharacters]="true"
        [control]="'region'"
      ></app-form-text-field>
    </ion-col>
    <!------------->

    <!-- District Code -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.DISTRICT"
        [maxLength]="2"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [autoCapitalizeCharacters]="true"
        [control]="'district'"
      ></app-form-text-field>
    </ion-col>
    <!------------->

    <!-- OPSYS ID -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.OPSYS_ID"
        [maxLength]="10"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [control]="'opsysId'"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="true"
      ></app-form-text-field>
    </ion-col>
    <!------------->

    <!-- CIS DEST -->
    <ion-col size="2">
      <app-form-text-field
        [labelText]="CONSTANTS.CIS_DEST"
        [maxLength]="7"
        [form]="form"
        [regexType]="REGEX.ALPHABET_NUMBER"
        [control]="'cisDest'"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="true"
      ></app-form-text-field>
    </ion-col>
    <!------------->

    <!-- COUNTRY -->
    <ion-col size="2">
      <div>
        <app-form-select
          formControlName="country"
          [label]="CONSTANTS.COUNTRY"
          [options]="countryList"
          [dropdownPosition]="DROPDOWN_POSITION"
          [required]="true"
          [hasRequiredSign]="true"
        >
        </app-form-select>
      </div>
    </ion-col>
    <!------------->

    <!-- EMPTY -->
    <ion-col size="2"> </ion-col>
    <!------------->
  </ion-row>
  <!------------->

  <!--- EMAILS -->
  <ion-row class="ion-margin-bottom">
    <!-- Primary Email -->
    <ion-col size="4">
      <app-form-text-field
        [labelText]="CONSTANTS.PRIMARY_EMAIL"
        [maxLength]="50"
        [form]="form"
        [control]="'primaryEmail'"
        [regexType]="REGEX.EMAIL"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="false"
      ></app-form-text-field>
    </ion-col>
    <!------------->
    <!-- Secondary Email -->
    <ion-col size="4">
      <app-form-text-field
        [labelText]="CONSTANTS.SECOND_EMAIL"
        [maxLength]="50"
        [form]="form"
        [control]="'secondaryEmail'"
        [regexType]="REGEX.EMAIL"
        [autoCapitalizeCharacters]="true"
        [hasRequiredSign]="false"
      ></app-form-text-field>
    </ion-col>
    <!------------->
    <!-- Timezone -->
    <ion-col size="4">
      <div>
        <app-form-select
          formControlName="timeZone"
          [label]="CONSTANTS.TIMEZONE"
          [options]="timezoneOptionList"
          [dropdownPosition]="DROPDOWN_POSITION"
          [required]="true"
        >
        </app-form-select>
      </div>
    </ion-col>
    <!------------->
  </ion-row>
  <!------------->
</form>
